import React, { useState } from 'react';
import './AddUrlForm.css';

function AddUrlForm({ onAdd, availableTags }) {
  const [url, setUrl] = useState('');
  const [tags, setTags] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTagClick = (tagName) => {
    const currentTags = tags
      .split(',')
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0);
    
    if (!currentTags.includes(tagName)) {
      const newTags = [...currentTags, tagName].join(', ');
      setTags(newTags);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!url.trim()) {
      setError('Please enter a URL');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const tagArray = tags
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag.length > 0);
      
      await onAdd({ url: url.trim(), tags: tagArray });
      
      setUrl('');
      setTags('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add URL');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-url-form">
      <h2>Add New Bookmark</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            disabled={loading}
            required
          />
        </div>
        
        {availableTags && availableTags.length > 0 && (
          <div className="available-tags">
            <div className="available-tags-list">
              {availableTags.map((tag, index) => (
                <button
                  key={index}
                  type="button"
                  className="quick-tag"
                  onClick={() => handleTagClick(tag.name)}
                  disabled={loading}
                >
                  {tag.name}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="form-group">
          <input
            type="text"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            placeholder="Tags (comma-separated): coding, tutorial, reference"
            disabled={loading}
          />
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <button type="submit" disabled={loading}>
          {loading ? '⏳ Adding...' : '➕ Add Bookmark'}
        </button>
      </form>
    </div>
  );
}

export default AddUrlForm;
